import { useContext } from 'react'

import CreateCancel from '../../../components/forms/CreateCancel'
import Tabel from '../../../components/tabel/Tabel'
import DashboardContext from '../../../Context'
import FromContact from './FromContact'

const Contact = () => {

    const { SohwaddFrom } = useContext(DashboardContext)

    return (
        <>
            <CreateCancel />
            {
                SohwaddFrom ?
                    <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '15px' }} >

                        <FromContact />
                    </div>
                    :
                    <Tabel />

            }
        </>
    )
}
export default Contact